export const animationsCSS = `
@keyframes typingPulse { 0%, 60%, 100% { opacity: 0.3; transform: scale(0.8); } 30% { opacity: 1; transform: scale(1); } }
@keyframes loadingPulse { 0%, 80%, 100% { opacity: 0.3; } 40% { opacity: 1; } }
@keyframes slideIn { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
@keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
@keyframes wave { 0%, 100% { height: 6px; } 50% { height: 16px; } }
@keyframes msgIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
`;

export const S = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100dvh',
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
    backgroundColor: 'var(--color-bg)',
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
    position: 'relative',
    overflow: 'hidden',
  },
  header: {
    backgroundColor: 'var(--color-primary)',
    color: 'var(--color-surface)',
    padding: '16px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 4px 16px rgba(11,26,74,0.15)',
    zIndex: 10,
    flexShrink: 0,
    minHeight: '56px',
  },
  headerStart: { display: 'flex', alignItems: 'center', gap: '10px' },
  headerLogo: {
    width: '38px',
    height: '38px',
    borderRadius: '10px',
    objectFit: 'contain',
    flexShrink: 0,
  },
  headerTitle: { fontSize: '16px', fontWeight: 600, lineHeight: 1.2 },
  headerSub: { fontSize: '12px', opacity: 0.85, display: 'flex', alignItems: 'center', gap: '5px' },
  statusDot: { width: '7px', height: '7px', borderRadius: '50%', display: 'inline-block' },
  typingBadge: { fontSize: '12px', opacity: 0.85, fontStyle: 'italic' },
  cartBtn: {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'var(--color-surface)',
    cursor: 'pointer',
    position: 'relative',
    padding: '6px',
    display: 'flex',
    alignItems: 'center',
  },
  cartBadge: {
    position: 'absolute',
    top: -2,
    right: -4,
    backgroundColor: 'var(--color-danger)',
    color: 'var(--color-surface)',
    fontSize: '10px',
    fontWeight: 700,
    borderRadius: '10px',
    padding: '1px 5px',
    minWidth: '16px',
    textAlign: 'center',
  },
  onboardingBar: {
    backgroundColor: 'var(--color-surface)',
    borderBottom: '1px solid var(--color-border)',
    flexShrink: 0,
    overflowX: 'auto',
  },
  onboardingSteps: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    gap: 0,
    minWidth: 'max-content',
  },
  onboardingStep: { display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 },
  onboardingDot: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '11px',
    fontWeight: 600,
    color: 'var(--color-surface)',
    flexShrink: 0,
  },
  onboardingLabel: { fontSize: '13px', whiteSpace: 'nowrap' },
  onboardingLine: { width: '28px', height: '2px', margin: '0 4px', flexShrink: 0 },
  chatArea: {
    flex: 1,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    padding: '12px 12px 0',
  },
  messagesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    maxWidth: '100%',
    paddingBottom: '16px',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px',
    gap: '12px',
  },
  loadingDots: { display: 'flex', gap: '6px' },
  loadingDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-secondary)',
    animation: 'loadingPulse 1.2s infinite ease-in-out',
  },
  loadingText: { fontSize: '14px', color: 'var(--color-text-secondary)' },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '50px 20px',
    textAlign: 'center',
  },
  emptyIcon: { fontSize: '48px', marginBottom: '16px' },
  emptyTitle: {
    fontSize: '22px',
    fontWeight: 700,
    color: 'var(--color-primary)',
    marginBottom: '8px',
  },
  emptyText: {
    fontSize: '14px',
    color: 'var(--color-text-secondary)',
    maxWidth: '320px',
    lineHeight: 1.5,
  },
  dateSeparator: { display: 'flex', justifyContent: 'center', padding: '12px 0 8px' },
  dateLabel: {
    fontSize: '12px',
    color: 'var(--color-text-secondary)',
    backgroundColor: 'var(--color-bg)',
    padding: '4px 12px',
    borderRadius: '8px',
    fontWeight: 500,
  },
  bubbleRow: { display: 'flex', alignItems: 'flex-end', gap: '6px', maxWidth: '100%' },
  botAvatar: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-bg-hover)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    flexShrink: 0,
    alignSelf: 'flex-end',
    marginBottom: '2px',
  },
  bubble: {
    maxWidth: '80%',
    padding: '9px 13px',
    borderRadius: '16px',
    wordBreak: 'break-word',
    position: 'relative',
    animation: 'msgIn 0.18s ease',
  },
  bubbleText: { fontSize: '15px', lineHeight: 1.45, whiteSpace: 'pre-wrap' },
  bubbleTime: { fontSize: '10.5px', marginTop: '3px', textAlign: 'right' },
  sistemaBubble: {
    maxWidth: '85%',
    padding: '8px 14px',
    borderRadius: '12px',
    backgroundColor: 'var(--color-danger-light)',
    color: 'var(--color-danger)',
    fontSize: '13px',
    textAlign: 'center',
    margin: '4px auto',
  },
  typingAnim: { display: 'flex', gap: '3px', alignItems: 'center', height: '8px' },
  typingDot: {
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-text-muted)',
    animation: 'typingPulse 1.4s infinite ease-in-out',
  },
  productCard: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '14px',
    padding: '10px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    border: '1px solid var(--color-bg)',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
    transition: 'box-shadow 0.15s',
  },
  productCardHighlight: {
    backgroundColor: '#e8f5e9',
    borderRadius: '14px',
    padding: '12px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    border: '1.5px solid #a5d6a7',
    boxShadow: '0 2px 6px rgba(76,175,80,0.12)',
  },
  pName: {
    fontSize: '13px',
    fontWeight: 600,
    color: 'var(--color-primary)',
    lineHeight: 1.4,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  pesableBadge: {
    fontSize: '10px',
    fontWeight: 600,
    padding: '1px 7px',
    borderRadius: '6px',
    backgroundColor: '#fef7e0',
    color: '#b06000',
  },
  addedBadge: {
    fontSize: '11px',
    fontWeight: 600,
    color: '#0d904f',
    whiteSpace: 'nowrap',
    backgroundColor: '#e8f5e9',
    padding: '3px 10px',
    borderRadius: '12px',
    flexShrink: 0,
  },
  addBtn2: {
    padding: '8px 16px',
    borderRadius: '20px',
    border: 'none',
    backgroundColor: 'var(--color-secondary)',
    color: 'var(--color-surface)',
    fontSize: '13px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    cursor: 'pointer',
    transition: 'background-color 0.15s, transform 0.1s',
  },
  verOpcionesBtn: {
    padding: '8px 16px',
    borderRadius: '20px',
    border: '1.5px solid var(--color-secondary)',
    backgroundColor: 'var(--color-surface)',
    color: 'var(--color-secondary)',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    alignSelf: 'flex-start',
    transition: 'background-color 0.15s',
  },
  toastContainer: {
    position: 'absolute',
    bottom: '80px',
    left: '12px',
    right: '12px',
    zIndex: 30,
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    pointerEvents: 'none',
  },
  toastStock: {
    backgroundColor: '#fff3e0',
    border: '1.5px solid #ff9800',
    borderRadius: '12px',
    padding: '10px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    boxShadow: '0 4px 12px rgba(255,152,0,0.25)',
    animation: 'slideUp 0.3s ease',
    pointerEvents: 'auto',
  },
  toastCart: {
    backgroundColor: 'var(--color-surface)',
    border: '1px solid var(--color-border)',
    borderRadius: '20px',
    padding: '8px 16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    animation: 'slideUp 0.25s ease',
    pointerEvents: 'auto',
    alignSelf: 'center',
    maxWidth: '90%',
  },
  toastTitle: { fontSize: '13px', fontWeight: 700, color: '#e65100', lineHeight: 1.2 },
  toastBody: { fontSize: '12px', color: '#bf360c', marginTop: '2px', lineHeight: 1.3 },
  cartPanel: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: '280px',
    maxWidth: '85vw',
    backgroundColor: 'var(--color-surface)',
    boxShadow: '-2px 0 12px rgba(0,0,0,0.1)',
    zIndex: 20,
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.25s ease',
  },
  cartHeader: {
    padding: '14px 16px',
    borderBottom: '1px solid var(--color-border)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeBtn: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--color-text-secondary)',
    display: 'flex',
  },
  cartItems: { flex: 1, overflowY: 'auto', padding: '8px 0' },
  cartItem: {
    padding: '10px 16px',
    borderBottom: '1px solid var(--color-bg)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },
  cantSmall: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    border: '1px solid var(--color-border)',
    backgroundColor: 'var(--color-bg)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--color-primary)',
  },
  cartFooter: {
    padding: '12px 16px',
    borderTop: '1px solid var(--color-border)',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  cartTotal: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '14px',
  },
  vaciarBtn: {
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid var(--color-border)',
    backgroundColor: 'var(--color-surface)',
    cursor: 'pointer',
    fontSize: '13px',
    color: 'var(--color-text-secondary)',
  },
  confirmarBtn: {
    padding: '10px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: 'var(--color-secondary)',
    color: 'var(--color-surface)',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
  },
  overlay: { position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.2)', zIndex: 15 },
  cartMobileOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    zIndex: 2000,
  },
  cartMobilePanel: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'var(--color-surface)',
    borderRadius: '20px 20px 0 0',
    maxHeight: '85vh',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2001,
    boxShadow: '0 -4px 32px rgba(0,0,0,0.15)',
    overflow: 'hidden',
  },
  inputArea: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 12px',
    backgroundColor: 'var(--color-surface)',
    borderTop: '1px solid var(--color-border)',
    gap: '8px',
    flexShrink: 0,
  },
  input: {
    flex: 1,
    padding: '10px 16px',
    borderRadius: '18px',
    border: '1px solid var(--color-border)',
    fontSize: '15px',
    outline: 'none',
    backgroundColor: 'var(--color-bg)',
    fontFamily: 'inherit',
    resize: 'none',
    overflow: 'hidden',
    lineHeight: 1.4,
    maxHeight: '120px',
    transition: 'border-color 0.2s',
  },
  sendBtn: {
    width: '42px',
    height: '42px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-secondary)',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    transition: 'opacity 0.2s',
  },
  gpsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px 0',
    flexWrap: 'wrap',
  },
  gpsBtn: {
    padding: '8px 16px',
    borderRadius: '20px',
    border: '1.5px solid var(--color-secondary)',
    backgroundColor: 'var(--color-bg-hover)',
    color: 'var(--color-secondary)',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    transition: 'background-color 0.15s',
  },
  gpsError: { fontSize: '12px', color: 'var(--color-danger)', fontWeight: 500 },
  gpsOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px',
  },
  gpsModal: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '16px',
    padding: '24px',
    width: '100%',
    maxWidth: '450px',
    boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
  },
  gpsModalTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: 'var(--color-primary)',
    margin: '0 0 16px',
  },
  gpsHint: {
    fontSize: '12px',
    color: 'var(--color-text-secondary)',
    textAlign: 'center',
    margin: '8px 0 0',
  },
  gpsModalActions: { display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' },
  gpsCancelBtn: {
    padding: '8px 16px',
    borderRadius: '8px',
    border: '1px solid var(--color-border)',
    backgroundColor: 'var(--color-surface)',
    color: 'var(--color-text-secondary)',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: 'inherit',
  },
  gpsConfirmBtn: {
    padding: '8px 20px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: 'var(--color-secondary)',
    color: 'var(--color-surface)',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 600,
    fontFamily: 'inherit',
  },
};


